export const countryConfig = {
    US: {code: '+1', minLength: 10, maxLength: 10, mask: '(###) ###-####'},
    CA: {code: '+1', minLength: 10, maxLength: 10, mask: '(###) ###-####'},
    MX: {code: '+52', minLength: 10, maxLength: 10, mask: '(##) ####-####'},
    IN: {code: '+91', minLength: 10, maxLength: 10, mask: '#####-#####'},
    GB: {code: '+44', minLength: 10, maxLength: 10, mask: '#### ### ####'},
    FR: {code: '+33', minLength: 9, maxLength: 9, mask: '## ## ## ## #'},
    DE: {code: '+49', minLength: 10, maxLength: 11, mask: '#### ### ####'},
    IT: {code: '+39', minLength: 10, maxLength: 10, mask: '### #######'},
    AU: {code: '+61', minLength: 9, maxLength: 9, mask: '#### ### ###'},
    NZ: {code: '+64', minLength: 9, maxLength: 9, mask: '### ### ####'},
    CN: {code: '+86', minLength: 11, maxLength: 11, mask: '### #### ####'},
    JP: {code: '+81', minLength: 10, maxLength: 10, mask: '###-####-####'},
    KR: {code: '+82', minLength: 9, maxLength: 10, mask: '###-####-####'},
    BR: {code: '+55', minLength: 10, maxLength: 11, mask: '(##) #####-####'},
    AR: {code: '+54', minLength: 10, maxLength: 10, mask: '(##) ####-####'},
    ZA: {code: '+27', minLength: 9, maxLength: 9, mask: '### ### ####'},
    NG: {code: '+234', minLength: 10, maxLength: 10, mask: '### #### ####'},
    KE: {code: '+254', minLength: 9, maxLength: 10, mask: '### ### ####'},
    RU: {code: '+7', minLength: 10, maxLength: 10, mask: '(###) ###-##-##'},
    UA: {code: '+380', minLength: 9, maxLength: 9, mask: '### ### ####'},
    SE: {code: '+46', minLength: 9, maxLength: 10, mask: '### ### ####'},
    NO: {code: '+47', minLength: 8, maxLength: 8, mask: '### ## ###'},
    DK: {code: '+45', minLength: 8, maxLength: 8, mask: '## ## ## ##'},
    FI: {code: '+358', minLength: 9, maxLength: 12, mask: '### ### ####'},
    NL: {code: '+31', minLength: 9, maxLength: 10, mask: '### ### ####'},
    BE: {code: '+32', minLength: 9, maxLength: 9, mask: '### ### ###'},
    AT: {code: '+43', minLength: 10, maxLength: 11, mask: '### ### ####'},
    CH: {code: '+41', minLength: 9, maxLength: 9, mask: '## ### ## ##'},
    ES: {code: '+34', minLength: 9, maxLength: 9, mask: '### ### ###'},
    PT: {code: '+351', minLength: 9, maxLength: 9, mask: '### ### ###'},
    GR: {code: '+30', minLength: 10, maxLength: 10, mask: '### ### ####'},
    TR: {code: '+90', minLength: 10, maxLength: 10, mask: '(###) ### ####'},
    SA: {code: '+966', minLength: 9, maxLength: 9, mask: '### ### ####'},
    AE: {code: '+971', minLength: 9, maxLength: 9, mask: '### ### ####'},
    SG: {code: '+65', minLength: 8, maxLength: 8, mask: '#### ####'},
    MY: {code: '+60', minLength: 9, maxLength: 10, mask: '###-### ####'},
    TH: {code: '+66', minLength: 9, maxLength: 10, mask: '### ### ####'},
    VN: {code: '+84', minLength: 9, maxLength: 10, mask: '### ### ####'},
    ID: {code: '+62', minLength: 9, maxLength: 11, mask: '### ### ####'},
    PH: {code: '+63', minLength: 10, maxLength: 10, mask: '### ### ####'},
    EG: {code: '+20', minLength: 10, maxLength: 10, mask: '### ### ####'},
    IQ: {code: '+964', minLength: 10, maxLength: 10, mask: '### ### ####'},
    IR: {code: '+98', minLength: 10, maxLength: 10, mask: '### ### ####'},
    PK: {code: '+92', minLength: 10, maxLength: 10, mask: '### ### ####'},
    BD: {code: '+880', minLength: 10, maxLength: 10, mask: '### ### ####'},
    LK: {code: '+94', minLength: 9, maxLength: 9, mask: '### ### ####'},
    NP: {code: '+977', minLength: 10, maxLength: 10, mask: '### ### ####'},
    HK: {code: '+852', minLength: 8, maxLength: 8, mask: '#### ####'},
    TW: {code: '+886', minLength: 9, maxLength: 10, mask: '### ### ####'},
  };
  